import React from 'react';
import classnames from 'classnames/bind';

import styles from './featuredRankStyles';

import StarIcon from 'SVGs/star';
import Icon from 'buyside/components/presentation/Icon/icon';

import { rankingUrl } from 'buyside/util/urlHelper';

const cx = classnames.bind(styles);

const FeaturedRank = ({ featuredRank, withMarginTop = false }) => {
  if (!featuredRank) return null;

  const winnerTextClass = cx({
    winnerText: true,
    recent: !featuredRank.current
  });
  const rankContainerClass = cx({
    rankContainer: true
  });
  const rankHeadingClass = cx({
    rankHeading: true,
    marginTop: withMarginTop
  });
  const starClass = cx({ star: true });

  let rankContent = (
    <a href={rankingUrl(featuredRank.category)}>
      <Icon type={StarIcon} style={starClass} />
      <strong className={winnerTextClass}>{featuredRank.rankString}</strong>
    </a>
  );

  if (!featuredRank.current) {
    rankContent = (
      <span>
        <Icon type={StarIcon} style={starClass} />
        <strong className={winnerTextClass}>{featuredRank.rankString}</strong>
      </span>
    );
  }

  return (
    <div className={rankContainerClass}>
      <p className={rankHeadingClass}>
        {featuredRank.current ? 'Current Ranking:' : 'Recent Ranking:'}
      </p>
      <div>{rankContent}</div>
    </div>
  );
};

export default FeaturedRank;
